import { render, staticRenderFns } from "./ObjektiCard2Tab-3-Prometi.vue?vue&type=template&id=0b35a338&scoped=true&"
import script from "./ObjektiCard2Tab-3-Prometi.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-3-Prometi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35a338",
  null
  
)

export default component.exports